import { pageNames } from '@atc/bonnet-paths';
import { resultsDuckCreator } from 'axl-ducks';

export default resultsDuckCreator({
    namespace: pageNames.DEALER_DETAILS,
    store: 'activeEmail',
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
